import { Field, Float, ID, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType, Severity } from '@typegoose/typegoose'
import GraphQLJSON from 'graphql-type-json'
import { Contact, generateEntityId } from '@ztechapps/common.contract'
import { HaulerSignature } from './HaulerSignature'
import { SyncInfo } from './SyncInfo'
import { HaulerLogo } from './HaulerLogo'
import { PlantBtu, PlantSilo } from '@ztechapps/totalmilk-tmms.common'
import { MilkPickupDriverRef } from './MilkPickupDriverRef'

@ObjectType()
export class MilkPickupDeliveryCustomer {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => SyncInfo, { nullable: true })
  @Prop({ type: SyncInfo })
  _syncInfo?: ReturnType<() => SyncInfo>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  type?: string

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => [PlantBtu], { nullable: true })
  @Prop({ type: [PlantBtu] }, PropType.ARRAY)
  btus?: ReturnType<() => PlantBtu[]>

  @Field(() => [PlantSilo], { nullable: true })
  @Prop({ type: [PlantSilo] }, PropType.ARRAY)
  silos?: ReturnType<() => PlantSilo[]>
}

@modelOptions({ schemaOptions: { strict: false }, options: { allowMixed: Severity.ALLOW } })
@ObjectType()
export class MilkPickupDelivery {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('mpkpdlv') })
  _id: string

  @Field(() => MilkPickupDeliveryCustomer, { nullable: true })
  @Prop({ type: MilkPickupDeliveryCustomer })
  customer?: ReturnType<() => MilkPickupDeliveryCustomer>

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  weight?: number

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  timeStamp?: Date

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  btus?: string[]

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  silos?: string[]

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => MilkPickupDriverRef, { nullable: true })
  @Prop({ type: MilkPickupDriverRef })
  driver?: ReturnType<() => MilkPickupDriverRef>

  @Field(() => HaulerSignature, { nullable: true })
  @Prop({ type: HaulerSignature })
  signature?: ReturnType<() => HaulerSignature>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  drugTest?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  drugResult?: string

  @Field(() => GraphQLJSON, { nullable: true })
  templateData?: Record<string, unknown>
}
